import { STATUS } from "@/constants/statuses";
import ProductEntity from "@modules/products/entities/ProductEntity";
import ProductVariantsEntity from "@modules/products/entities/ProductVariantsEntity";
import { ProductsQuery } from "@modules/products/queries/ProductsQuery";
import { combineLatest, map } from "rxjs";

export const createProductInfoObservable = (
    productsQuery: ProductsQuery,
    productId: number,
    variantId: number | null
) => {
    return combineLatest([
        productsQuery.selectProductAndVariant(productId, variantId),
        productsQuery.selectProductStatus(productId),
    ]).pipe(
        map(([{ product, variant }, status]) => {
            if (status === STATUS.READY) {
                return {
                    status,
                    product,
                    variant,
                } as {
                    status: typeof status;
                    product: ProductEntity;
                    variant?: ProductVariantsEntity;
                };
            }
            return {
                status,
                product: null,
                variant: null,
            };
        })
    );
};
